import React from 'react';
import './Blog.css';

const Blog = () => {
    return (
        <>
        <section className="blog">
            <div className="text-light text-center">
                <h1 className="py-5">Blogs Coming Soon...</h1>
            </div>
        </section>
        
        </>
    );
};

export default Blog;